import {createBrowserHistory} from 'history';

const browserHistory = createBrowserHistory();

// 已关联至App.tsx中的总Router，其他页面或utils模块可直接从引入此文件，使用 History.push 即可做路由跳转
export default browserHistory;
